import { getUrlValue } from 'utilities/content/linkUrls'
import { BottomNavState, NavigationTab, NavigationTabIcon } from './types'

export const getDefaultNavigationTabIcon = (): NavigationTabIcon => ({
  id: null,
  url: '',
  file_upload_id: undefined,
})

export const createNavigationTab = (
  id: string | number,
  overrides: Partial<NavigationTab> = {}
): NavigationTab => ({
  id,
  name: '',
  link: getUrlValue(''),
  position: 1,
  default_icon: undefined,
  selected_icon: undefined,
  ...overrides,
})

export const initialState: BottomNavState = {
  navigation_tabs: {
    'tab-1': {
      id: 'tab-1',
      name: 'Home',
      link: getUrlValue('thanx://home'),
      position: 1,
    },
    'tab-2': {
      id: 'tab-2',
      name: 'Rewards',
      link: getUrlValue('thanx://rewards'),
      position: 2,
    },
    'tab-3': {
      id: 'tab-3',
      name: 'Orders',
      link: getUrlValue('thanx://orders'),
      position: 3,
    },
    'tab-4': {
      id: 'tab-4',
      name: 'Profile',
      link: getUrlValue('thanx://profile'),
      position: 4,
    },
  },
  hasChanges: false,
  isSubmitting: false,
  deleteModal: {
    isOpen: false,
    tabId: null,
  },
}

export default initialState
